import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Subject } from 'rxjs';

@Injectable()
export class RatingAndReviewService {
  updateCommentsCount = new Subject();
  constructor(private httpClient: HttpClient) {}
  postRateAndReview(data): Observable<any> {
    return this.httpClient.post(`/RatingsAndReviews`, data);
  }
  subscribeToItemsCountChange() {
    return this.updateCommentsCount.asObservable();
  }
  updateRateAndReview(id: string, data): Observable<any> {
    return this.httpClient.patch(`/RatingsAndReviews/edit/${id}`, data);
  }
  getReviewList(postId: string) {
    const body = {
      postId: postId,
      fields: ['id', 'userId', 'postId', 'review'],
      limit: 10,
      skip: 0
    }

    return this.httpClient.post(`/RatingsAndReviews/get-list`, body);
  }

  getSelfReview(postId: string, userId : string) {
    const body = {
      postId: postId,
      fields: ['id', 'userId', 'postId', 'review'],
      limit: 10,
      skip: 0,
      userId :userId
    }

    return this.httpClient.post(`/RatingsAndReviews/get-list`, body);
  }
}



// WEBPACK FOOTER //
// ./src/app/feature/main/roles-shared/services/rating-and-review.service.ts